/**
 * Sentry Configuration Constants
 *
 * Shared Sentry configuration used across webapp and mobile applications.
 * This ensures consistent error filtering and monitoring behavior.
 */

export { COMMON_IGNORE_ERRORS, WEBAPP_IGNORE_ERRORS, MOBILE_IGNORE_ERRORS } from './ignoreErrors';
export { beforeSend } from './beforeSend';
